import React from 'react';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { useGlobalLocale } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';

export const RegisterZPSkeleton = () => {
	const { t } = useGlobalLocale();
	return (
		<LayoutGap>
			<ContentLayout>
				<div className="flex items-start gap-8 mb-4">
					<GovSkeleton
						width="70px"
						height="32px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width="132px"
						height="32px"
						aria-label={t('loading.wcag.processing')}
					/>
				</div>
				{Array.from({ length: 2 }).map((_) => (
					<div className="p-6 mt-5!">
						<GovSkeleton
							width="240px"
							height="24px"
							aria-label={t('loading.wcag.processing')}
							className="mb-2!"
						/>
						<div className="flex gap-1 flex-wrap">
							<GovSkeleton
								width="40px"
								height="20px"
								aria-label={t('loading.wcag.processing')}
							/>
							<GovSkeleton
								width="80px"
								height="20px"
								aria-label={t('loading.wcag.processing')}
							/>
							<GovSkeleton
								width="40px"
								height="20px"
								aria-label={t('loading.wcag.processing')}
								className="mr-1"
							/>
							<GovSkeleton
								width="160px"
								height="20px"
								aria-label={t('loading.wcag.processing')}
							/>
						</div>
						<GovSkeleton
							width="100px"
							height="20px"
							aria-label={t('loading.wcag.processing')}
							className="mt-5!"
						/>
					</div>
				))}
			</ContentLayout>
		</LayoutGap>
	);
};
